import { Component, OnChanges,Input,Output,EventEmitter} from '@angular/core';
import { LoadingService } from '../../share/service/loading.service';
import { ApiService } from '../../share/service/api.service';
declare var jslib;
@Component({
  selector: 'eventCard',
  templateUrl: './eventCard.component.html'
})
export class eventCardComponent implements OnChanges 
{
  @Input() BuyerData; 
  @Input() EventData;
  @Output() Event = new EventEmitter();
  constructor(
    private pop : LoadingService,
    private baseapi : ApiService
  ) {
    
  }
  public EventMap = '';
  ngOnChanges() {
    //console.log('event BuyerData',this.BuyerData);
    //console.log('event EventData',this.EventData);
    //額外處理map
    if(this.EventData.infoItems && this.EventData.infoItems.length > 0){
      var isMap = this.EventData.infoItems.findIndex( _info =>{
        return _info['name'] == 'map';
      });
      if(isMap > -1){
      var map = this.EventData.infoItems.splice(isMap,1);
      //console.log('map',map);
      this.EventMap = map[0]['description'];
      }
    }
  }
  public IsShow = false;
  ToggleCard(){
    this.IsShow = !this.IsShow;
  }
}
